import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pay-conform" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "dialog-title" }
const _hoisted_4 = { class: "dialog-tip" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  style: {"padding":"0 15px 20px"}
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "paypal-tip" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  style: {"color":"#007AFF"},
  class: "paypal-text"
}
const _hoisted_13 = { class: "flex-ter-cen" }

import { t } from '@/plugins/i18n'
import { ref, watch, computed } from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'
import CheckRadio from '@/components/checkRadio/index.vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { useRtfix, isJA } from '@/store'

import dayjs from 'dayjs'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  beforehandVipInfo: {
    type: Object,
    default: () => { return {} }
  }
},
  emits: ['update:visible', 'submit'],
  setup(__props, { expose, emit }) {

const props = __props
const store = useStore()


const userInfo = computed(() => {
  return store.getters.user
})
const title = ref('')
const tip1 = ref('')
const tip2 = ref('')
const vipInfo = ref({})
const showRadio = ref(false)
const open = (vipInfo1: any) => {
  vipInfo.value = vipInfo1
  console.log('props.beforehandVipInfo', props.beforehandVipInfo.membershipTemplateName)
  if (props.beforehandVipInfo.membershipTemplateName) {
    console.log('如果是预充会员')
    // 如果是预充会员
    if (userInfo.value.membership.templateLevel === vipInfo.value.templateLevel) {
      // 续费
      title.value = t('续费提示')
      tip1.value = t('续费后，会在XX开始自动延长YY时间').replace('XX', `<span style="color:#EB4545;">${userInfo.value.membership.expiresDate}</span>`).replace('YY', `<span style="color:#EB4545;">【${userInfo.value.membership.membershipTemplateName}】</span>`)
      tip2.value = t('检测到您当前有T1至T2的预充会员，续费成功后，会取消原来预充的会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。').replace('T1', dayjs(props.beforehandVipInfo?.oldExpiresDate).add(1, 'day').format('YYYY-MM-DD')).replace('T2', dayjs(props.beforehandVipInfo?.expiresDate).format('YYYY-MM-DD')).replaceAll('V', props.beforehandVipInfo.membershipTemplateName)
      showRadio.value = false
    }
    if (userInfo.value.membership.templateLevel < vipInfo.value.templateLevel) {
      //  升舱
      showRadio.value = true
      tip2.value = ''
      title.value = t('升舱提示')
      tip1.value = t('您当前为V1，想开通V2，您想选择何时生效？开通成功后，选择将不可更改').replaceAll('V1', `<span style="color:#EB4545;">【${userInfo.value.membership.membershipTemplateName}】</span>`).replaceAll('V2', `<span style="color:#EB4545;">【${vipInfo.value.priceName}】</span>`)
      checkValue.value = 1
    }
    if (userInfo.value.membership.templateLevel > vipInfo.value.templateLevel) {
      //  降舱
      showRadio.value = false
      tip2.value = t('检测到您当前有T1至T2的预充会员，降仓成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。').replace('T1', dayjs(props.beforehandVipInfo?.oldExpiresDate).add(1, 'day').format('YYYY-MM-DD')).replace('T2', dayjs(props.beforehandVipInfo?.expiresDate).format('YYYY-MM-DD')).replaceAll('V1', props.beforehandVipInfo.membershipTemplateName)
      title.value = t('降舱提示')
      tip1.value = t('您当前为V1，想开通V2，为保障您当前的会员权益，会等原会员套餐到期（TT）后开始实行降仓会员，是否要进行降仓？').replaceAll('V1', `<span style="color:#EB4545;">【${userInfo.value.membership.membershipTemplateName}】</span>`).replaceAll('V2', `<span style="color:#EB4545;">【${vipInfo.value.priceName}】</span>`).replace('TT', userInfo.value.membership.expiresDate)
    }
  } else {
    // 非预充会员
    if (userInfo.value.membership.templateLevel === vipInfo.value.templateLevel) {
      // 续费
      title.value = t('续费提示')
      tip1.value = t('续费后，会在T开始自动延长V时间').replace('T', `<span style="color:#EB4545;">${userInfo.value.membership.expiresDate}</span>`).replace('V', `<span style="color:#EB4545;">【${userInfo.value.membership.membershipTemplateName}】</span>`)
      tip2.value = ''
      showRadio.value = false
    }
    if (userInfo.value.membership.templateLevel < vipInfo.value.templateLevel) {
      //  升舱
      showRadio.value = true
      tip2.value = ''
      title.value = t('升舱提示')
      tip1.value = t('您当前为V1，想开通V2，您想选择何时生效？开通成功后，选择将不可更改').replaceAll('V1', `<span style="color:#EB4545;">【${userInfo.value.membership.membershipTemplateName}】</span>`).replaceAll('V2', `<span style="color:#EB4545;">【${vipInfo.value.priceName}】</span>`)
      checkValue.value = 1
    }
    if (userInfo.value.membership.templateLevel > vipInfo.value.templateLevel) {
      //  降舱
      showRadio.value = false
      tip2.value = ''
      title.value = t('降舱提示')
      tip1.value = t('您当前为V1，想开通V2，为保障您当前的会员权益，会等原会员套餐到期（TT）后开始实行降仓会员，是否要进行降仓？').replaceAll('V1', `<span style="color:#EB4545;">【${userInfo.value.membership.membershipTemplateName}】</span>`).replaceAll('V2', `<span style="color:#EB4545;">【${vipInfo.value.priceName}】</span>`).replace('TT', userInfo.value.membership.expiresDate)
    }
  }
}


const checkValue = ref()
watch(checkValue, (newValue) => {
  if (props.beforehandVipInfo.membershipTemplateName) {
    // 预充会员
    tip2.value = newValue === 1 ? t('检测到您当前有2段会员，升舱成功后，会取消当前会员和预充会员，<span style="color:#EB4545;">钱款不予退还</span>。').replace('V1', userInfo.value.membership.membershipTemplateName).replace('V2', props.beforehandVipInfo.membershipTemplateName) : t('检测到您当前有T1至T2的预充会员，升舱成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>').replace('T1', dayjs(props.beforehandVipInfo?.oldExpiresDate).add(1, 'day').format('YYYY-MM-DD')).replace('T2', dayjs(props.beforehandVipInfo?.expiresDate).format('YYYY-MM-DD')).replaceAll('V', props.beforehandVipInfo.membershipTemplateName)
  } else {
    tip2.value = newValue === 1 ? t('如果您现在更改会员计划，您当前的会员资格将失效。请注意，会员费不可退还。') : ''
  }
})
const radioList = [
  {
    name: t('立即生效'),
    value: 1
  },
  {
    name: t('{time}开始生效', { time: dayjs(userInfo.value?.membership.expiresDate).add(1, 'day').format('YYYY-MM-DD') }),
    value: 2
  }
]
const close = () => {
  checkValue.value = 0
  emit('update:visible', false)
}

const submit = () => {
  emit('submit', {
    vipInfo: vipInfo.value,
    checkValue: checkValue.value
  })
}
expose({
  open
})


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "custom-class": "pay-confirm-dialog",
      "model-value": __props.visible,
      "destroy-on-close": "",
      onClose: close,
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(title.value), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "tip1",
              innerHTML: tip1.value
            }, null, 8, _hoisted_5),
            (showRadio.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(CheckRadio, {
                    list: radioList,
                    activeValue: checkValue.value,
                    "onUpdate:activeValue": _cache[0] || (_cache[0] = ($event: any) => ((checkValue).value = $event))
                  }, null, 8, ["activeValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "tip2",
              innerHTML: tip2.value
            }, null, 8, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("span", {
                innerHTML: _unref(t)('请及时关闭PayPal账户内不需要的自动续费，如未关闭，我们会将这笔钱充值到您的余额，可能需要您承担部分手续费。')
              }, null, 8, _hoisted_11),
              _createVNode(_component_router_link, {
                to: _unref(useRtfix)('RenewalCourse'),
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_unref(t)('关闭PayPal自动续费教程')) + " ", 1),
                    _createVNode(_component_el_icon, { class: "icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowRight))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_button, {
            class: "btn",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "btn",
            style: {"margin-left":"20px"},
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})